import { render } from "./BlogWeddingGiftsView.vue?vue&type=template&id=525d7832"
import script from "./BlogWeddingGiftsView.vue?vue&type=script&lang=js"
export * from "./BlogWeddingGiftsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__